import React, {useContext} from 'react';
import {
  Collapse,
  Navbar,
  NavItem,
  Nav,
  NavLink,
  Card,
  CardBody
} from 'reactstrap';
import AppContext, {ProductContext} from '../../context/Context';
import Logo from './Logo';
import {withRouter} from 'react-router-dom';
import NavbarDropdown from './NavbarDropdown';
import * as AuthUtils from './../../helpers/authUtils';

const NavbarTop = ({match, history}) => {
  const {showBurgerMenu, setShowBurgerMenu} = useContext(AppContext);
  const {shoppingCart} = useContext(ProductContext);
  const logout = () => {
    localStorage.removeItem('jwt');
    history.push('/');
  };
  const profileSettingsHandler = () => {
    window.location = '/settings';
  };
  const getUserName = () => {
    const auth = AuthUtils.getAuth();
    if (auth && auth.name) {
      
      const userName = auth.name.split(' ');
      return userName[0];
    }
    return null;
  };
  return (
    <Navbar
      light
      className="navbar-glass fs--1 font-weight-semi-bold row navbar-top sticky-kit"
      expand
    >
      <div className="toggle-icon-wrapper d-xl-none">
        <button
          className="navbar-vertical-toggle btn btn-link d-flex align-item-center justify-content-center "
          onClick={() => {
            setShowBurgerMenu(!showBurgerMenu);
          }}
          id="burgerMenu"
        >
          <span className="navbar-toggle-icon">
            <span className="toggle-line" />
          </span>
        </button>
      </div>
      <Logo at="navbar-top" width={40} id="topLogo" />
      <Collapse isOpen={true} navbar>
        <Nav navbar className="ml-auto text-capitalize">
          <NavbarDropdown title={`Hello, ${getUserName()}`} right>
            <ul className="list-group cursor-pointer">
              <li
                className="list-group-item"
                onClick={() => {
                  profileSettingsHandler();
                }}
              >
                {'Profile Settings'}
              </li>
              <li
                className="list-group-item"
                onClick={() => {
                  logout();
                }}
              >
                {'LogOut'}
              </li>
            </ul>
          </NavbarDropdown>
        </Nav>
      </Collapse>
    </Navbar>
  );
};

export default withRouter(NavbarTop);
